import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import ChartTypes from "@/components/ChartTypes.tsx";

@Component
export default class ReadingInfo extends Vue {
  @Prop({ default: null }) studentId!: string;
  private sections: any;
  private color = ["red", "green", "#FFA500"];

  private tasks: any;
  private skills: any;

  created() {
    this.tasks = this.$store.getters.teacherDashboard.bala.descriptions.tasks;
    this.skills = this.$store.getters.teacherDashboard.bala.descriptions.skills;
    this.sections = [];
  }

  stateLoaded() {
    if (this.sections.length > 0) return true;

    let tasks = this.tasks;
    let skills = this.skills;
    if (tasks != undefined && skills != undefined) {
      Object.keys(skills).forEach((item: any) => {
        let obj = skills[item];
        this.sections.push({
          selected: false,
          description: obj.description,
          postDesc: obj.questionsLikeThis,
          name: obj.name,
          color: obj.color
        });
      });
      return true;
    }
    return false;
  }

  render(h: CreateElement) {
    return (
      this.stateLoaded() && (
        <v-card>
          <v-card-title
            class="mx-auto text-center"
            style={{ paddingBottom: 0 }}
          >
            <span>Assessment Metrics</span>
          </v-card-title>
          <v-card-text>
            Information about assessed teslets and skills.
            <v-row dense>
              <v-col cols="5">
                <v-simple-table dense overflow-x="hidden">
                  <thead>
                    <tr>
                      <th>Testlests</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.values(this.tasks).map((task: any) => (
                      <tr>
                        <td>{task.name}</td>
                      </tr>
                    ))}
                  </tbody>
                </v-simple-table>
              </v-col>
              <v-col cols="7">
                <v-simple-table dense overflow-x="hidden">
                  <thead>
                    <tr>
                      <th>Skills</th>
                    </tr>
                  </thead>
                  <tbody style={{ height: "inherit", overflowX: "hidden" }}>
                    {Object.values(this.skills).map((task: any) => (
                      <tr>
                        <td>{task.name}</td>
                      </tr>
                    ))}
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
            <br />
            Description of individual skills assessed.
            <v-list>
              {this.sections != [] &&
                this.sections.map((item: any, i: number) => (
                  <span>
                    <v-list-item
                      onClick={() => {
                        this.sections[i].selected = !this.sections[i].selected;
                        this.$forceUpdate();
                      }}
                      color={this.color[i]}
                      style={{
                        backgroundColor: "#FBFBFB",
                        marginBottom: "5px"
                      }}
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          <span>{item.name}</span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-dialog
                      v-model={this.sections[i].selected}
                      content-class="cardDialog"
                    >
                      <Card
                        title={this.sections[i].name}
                        titleType="toolbar"
                        titleColor={this.sections[i].color}
                      >
                        <div slot="mainContent">
                          <p>{this.sections[i].description}</p>
                          <p>{this.sections[i].postDesc}</p>
                        </div>
                        <div slot="actions">
                          <v-btn
                            onClick={() => {
                              this.sections[i].selected = false;
                              this.$forceUpdate();
                            }}
                          >
                            Close
                          </v-btn>
                        </div>
                      </Card>
                    </v-dialog>
                  </span>
                ))}
            </v-list>
          </v-card-text>
        </v-card>
      )
    );
  }
}

const component = ReadingInfo;
